module.exports = __webpack_public_path__ + "img/bj3.39d92526.png";